<template>
    <div class="content-block">
      <div class="content-block__header" :style="headerStyle">
        <span class="content-block__title"
              v-stop-draggable
              :class="{'content-block__title_long': slotLess,
                       'content-block__title_small': titleLeft}"
              v-html="title"
        >
        </span>
        <slot name="title-left"></slot>
        <div class="content-block__header-additional" v-if="!slotLess">
          <slot name="title-additional"></slot>
        </div>
      </div>
      <div class="content-block__content">
        <slot></slot>
      </div>
    </div>
</template>

<script>
  /**
   * content wrapper with additional header slot
   */
  export default {
  name: 'BaseContentBlock',
  props: [
    'title', 'slotLess', 'titleLeft', 'headerStyle'
  ]
}
</script>

<style scoped lang="scss">
  .content-block {
    background-color: #fff;
    border-radius: $rfx-default-border-radius;
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(1, 22, 39, 0.1);

    &__header {
      display: flex;
      flex: 1 1 60px;
      min-height: 60px;
      box-sizing: border-box;
      padding: 0 30px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid $rfx-light-steel;

      &-additional {
        flex: 1 1 60%;
        display: flex;
        justify-content: flex-end;
      }
    }

    &__content {
      flex: 1 1 100%;
      display: flex;
      align-items: stretch;
    }

    &__title {
      flex: 1 1 40%;
      font-weight: 500;
      color: $rfx-dark-march;
      font-size: 18px;
      @include ellipsis;

      &_long{
        flex: 1 1 100%;
      }

      &_small {
        flex: none;
      }
    }
  }
</style>
